import React, {useEffect, useRef, useState} from 'react'
import {Tooltip} from 'antd'
import { Scrollbar } from "smooth-scrollbar-react";
import type { Scrollbar as BaseScrollbar } from "smooth-scrollbar/scrollbar";
import ScrollShadow from 'react-scroll-shadow';
import {connect} from "react-redux";
import './index.scss'

const CustomTooltip: React.FC<any> = (props : any) => {
    const tooltip_content=useRef<any>(null);
    const scrollbar = useRef<BaseScrollbar | null>(null);


    const VisibleChange = (visible) => {


        if (visible){

        }
    }
    
    const onScroll = (e) => {
        document.querySelector('.ant-tooltip-content')?.classList.add('has_scroll_bar');
    }

    return (
        <Tooltip
            overlayClassName={`tabs_tooltip ${props?.className} `}
            placement={props?.placement || "top"}
            ref={tooltip_content}
            visible = {props.visible}
            onVisibleChange={VisibleChange}
            title={props.title}
            style={props.style}
            trigger={props.trigger}
            destroyTooltipOnHide={false}
            overlay={
                /*<ScrollShadow
                    bottomShadowColors={{
                        active: 'red',
                        inactive: 'white'
                    }}
                    topShadowColors={{
                        active: 'blue',
                        inactive: 'white'
                    }}
                    shadowSize={20}
                >
                    <div dangerouslySetInnerHTML={{__html: props.title}} />
                </ScrollShadow>*/

                <Scrollbar
                    ref={scrollbar}
                    alwaysShowTracks={true}
                    onScroll={onScroll}
                >
                    <div dangerouslySetInnerHTML={{__html: props.title}} onClick={props?.onClick} />
                </Scrollbar>
            }
        >
            {props.children}
        </Tooltip>
    )
}

export default connect(null, null)(CustomTooltip);
